export * from 'SourceRoute/ProductPage/ProductPage.config';

// eslint-disable-next-line import/prefer-default-export
export const SWATCH_COLOR_KEY = 'swatch';
export const RECOMMENDER_PDP_ID = 'related1';
